import type { ElementType, ReactNode } from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useSidebar } from '@src/app/layout';
import Link from '@src/shared/ui/Link';

interface SidebarItemProps {
  label?: ReactNode;
  icon?: ReactNode;
  endIcon?: ReactNode;
  active?: boolean;
  component?: ElementType;
  [key: string]: unknown;
}

const StyleSheet = {
  listItemButton: {
    fontSize: '1rem',
    fontWeight: 500,
    padding: '13px 18px',
    transition: 'none',
    '&:hover, &.Mui-active': {
      backgroundColor: 'primary.main',
      color: 'common.white',
    },
  },
  listItemIcon: {
    color: 'currentColor',
    minWidth: '24px',
    mr: '18px',
  },
  listItemText: {
    m: 0,
    whiteSpace: 'nowrap',
    flex: 1,
  },
};

function SidebarItem(props: SidebarItemProps) {
  const { label, icon, endIcon, active, component, ...restProps } = props;

  const sidebar = useSidebar();
  if (!sidebar) {
    return null;
  }
  const { isExpanded } = sidebar;

  return (
    <ListItem disablePadding>
      <ListItemButton
        sx={StyleSheet.listItemButton}
        className={active ? 'Mui-active' : undefined}
        component={component ?? Link}
        {...restProps}
      >
        <ListItemIcon sx={StyleSheet.listItemIcon}>{icon}</ListItemIcon>

        {isExpanded ? (
          <>
            <ListItemText
              disableTypography
              primary={label}
              sx={StyleSheet.listItemText}
            />
            {endIcon}
          </>
        ) : null}
      </ListItemButton>
    </ListItem>
  );
}

SidebarItem.displayName = 'SidebarItem';
export default SidebarItem;
